import { useState } from "react";
import { FindIdVerificationResponse } from "../../types/auth";
import { apiClient } from "../../utils/api";

export const useFindId = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [verificationResult, setVerificationResult] = useState<FindIdVerificationResponse | null>(null);
  const [foundId, setFoundId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const verifyPhoneNumber = async (phoneNumber: string) => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await apiClient.post<FindIdVerificationResponse>("/api/v1/auth/sms/id/verification", {
        contact_hp: phoneNumber,
      });

      if (response.status) {
        setVerificationResult(response.data);
        if (response.data.platform) {
          alert(`${response.data.platform} 계정으로 가입된 아이디입니다.`);
        } else if (response.data.unmatched) {
          alert("입력하신 전화번호로 가입된 계정이 없습니다.");
        } else {
          alert("입력하신 전화번호로 인증번호가 발송되었습니다.");
        }
      }
      return response.data;
    } catch (error) {
      setError("계정 확인 중 오류가 발생했습니다. 다시 시도해주세요.");
      console.error("Find ID verification error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const verifyCode = (inputCode: string) => {
    setError(null);
    if (!verificationResult?.authcode) {
      setError("인증번호가 만료되었습니다. 다시 시도해주세요.");
      return false;
    }

    if (inputCode === verificationResult.authcode) {
      setFoundId(verificationResult.ref_id || null);
      return true;
    } else {
      setError("인증번호가 일치하지 않습니다. 다시 확인해주세요.");
      return false;
    }
  };

  const resetVerification = () => {
    setVerificationResult(null);
    setFoundId(null);
    setError(null);
  };

  return {
    isLoading,
    verificationResult,
    verifyPhoneNumber,
    verifyCode,
    foundId,
    error,
    resetVerification,
  };
}; 